
export const goContextConfig =
{
    "@context": {
        "gomodel": "http://model.geneontology.org/",
        "BIOMD": "http://www.ebi.ac.uk/compneur-srv/biomodels-main/publ-model.do?mid=",
        "COG_Function": "http://www.ncbi.nlm.nih.gov/COG/grace/shokog.cgi?fun=",
        "WB": "http://identifiers.org/wormbase/",
        "FBbt": "http://purl.obolibrary.org/obo/FBbt_",
        "KEGG_LIGAND": "http://www.genome.jp/dbget-bin/www_bget?cpd:",
        "PSO_GIT": "https://github.com/Planteome/plant-stress-ontology/issues/",
        "MaizeGDB_stock": "http://maizegdb.org/data_center/stock?id=",
        "EMAPA": "http://purl.obolibrary.org/obo/EMAPA_",
        "GO": "http://purl.obolibrary.org/obo/GO_",
        "NCBI_GP": "http://www.ncbi.nlm.nih.gov/entrez/viewer.fcgi?db=protein&val=",
        "NMPDR": "http://www.nmpdr.org/linkin.cgi?id=",
        "CASSPC": "http://research.calacademy.org/research/ichthyology/catalog/getname.asp?rank=Species&id=",
        "TGD_REF": "http://db.ciliate.org/cgi-bin/reference/reference.pl?dbid=",
        "NCBIGene": "http://identifiers.org/ncbigene/",
        "KEGG_REACTION": "http://www.genome.jp/dbget-bin/www_bget?rn:",
        "PseudoCAP": "http://v2.pseudomonas.com/getAnnotation.do?locusID=",
        "UniPathway": "http://www.grenoble.prabi.fr/obiwarehouse/unipathway/upa?upid=",
        "MEROPS_fam": "http://merops.sanger.ac.uk/cgi-bin/famsum?family=",
        "GO_REF": "http://purl.obolibrary.org/obo/go/references/",
        "VEGA": "http://vega.sanger.ac.uk/id/",
        "ZFIN": "http://identifiers.org/zfin/",
        "AspGD_REF": "http://www.aspergillusgenome.org/cgi-bin/reference/reference.pl?dbid=",
        "RO": "http://purl.obolibrary.org/obo/RO_",
        "Pfam": "http://pfam.xfam.org/family/",
        "UBERON": "http://purl.obolibrary.org/obo/UBERON_",
        "GR": "http://www.gramene.org/db/searches/browser?search_type=All&RGN=on&query=",
        "PDB": "http://www.rcsb.org/pdb/cgi/explore.cgi?pdbId=",
        "CORIELL": "http://ccr.coriell.org/Sections/Search/Sample_Detail.aspx?Ref=",
        "JCVI_GenProp": "http://cmr.jcvi.org/cgi-bin/CMR/shared/GenomePropDefinition.cgi?prop_acc=",
        "SGN": "http://identifiers.org/sgn/",
        "BFO": "http://purl.obolibrary.org/obo/BFO_",
        "Genesys-pgr": "https://www.genesys-pgr.org/acn/search?q=",
        "UniMod": "http://www.unimod.org/modifications_view.php?editid1=",
        "UM-BBD_reactionID": "http://eawag-bbd.ethz.ch/servlets/pageservlet?ptype=r&reacID=",
        "PubChem_Substance": "http://www.ncbi.nlm.nih.gov/entrez/query.fcgi?CMD=search&DB=pcsubstance&term=",
        "EcoCyc": "http://biocyc.org/ECOLI/NEW-IMAGE?type=PATHWAY&object=",
        "Reactome": "http://identifiers.org/reactome/",
        "InterPro": "http://identifiers.org/interpro/",
        "UniRule": "http://www.uniprot.org/unirule/",
        "MGCSC_GENETIC_STOCKS": "http://www.maizegdb.org/cgi-bin/displaystockrecord.cgi?id=",
        "dictyBase": "http://identifiers.org/dictybase/",
        "PO_GIT": "https://github.com/Planteome/plant-ontology/issues/",
        "AspGD_LOCUS": "http://identifiers.org/aspgd.locus/",
        "SGD": "http://identifiers.org/sgd/",
        "COG_Pathway": "http://www.ncbi.nlm.nih.gov/COG/new/release/coglist.cgi?pathw=",
        "ENZYME": "http://www.expasy.ch/cgi-bin/nicezyme.pl?",
        "PAMGO_MGG": "http://scotland.fgl.ncsu.edu/cgi-bin/adHocQuery.cgi?adHocQuery_dbName=smeng_goannotation&Action=Data&QueryName=Functional+Categorization+of+MGG+GO+Annotation&P_KeyWord=",
        "AgBase": "http://www.agbase.msstate.edu/cgi-bin/getEntry.pl?db_pick=[ChickGO/MaizeGO]&uid=",
        "AraCyc": "http://www.arabidopsis.org:1555/ARA/NEW-IMAGE?type=NIL&object=",
        "EcoCyc_REF": "http://biocyc.org/ECOLI/reference.html?type=CITATION-FRAME&object=",
        "CHEBI": "http://purl.obolibrary.org/obo/CHEBI_",
        "HGNC": "http://identifiers.org/hgnc/",
        "dictyBase_gene_name": "http://dictybase.org/gene/",
        "TAIR": "http://identifiers.org/tair.locus/",
        "EnsemblFungi": "http://www.ensemblgenomes.org/id/",
        "Wikipedia": "http://en.wikipedia.org/wiki/",
        "SUPERFAMILY": "http://supfam.cs.bris.ac.uk/SUPERFAMILY/cgi-bin/scop.cgi?ipid=SSF",
        "SWALL": "http://ca.expasy.org/cgi-bin/sprot-search-de?S=1&amp;T=1&amp;SEARCH=",
        "PSI-MOD": "http://www.ebi.ac.uk/ontology-lookup/?termId=MOD:",
        "FYPO": "http://purl.obolibrary.org/obo/FYPO_",
        "RGD": "http://identifiers.org/rgd/",
        "UM-BBD_enzymeID": "http://eawag-bbd.ethz.ch/servlets/pageservlet?ptype=ep&enzymeID=",
        "Broad_MGG": "http://www.broad.mit.edu/annotation/genome/magnaporthe_grisea/GeneLocus.html?sp=S",
        "Swiss-Prot": "http://www.ebi.uniprot.org/uniprot-srv/uniProtView.do?proteinac=",
        "PMID": "http://www.ncbi.nlm.nih.gov/pubmed/",
        "Xenbase": "http://identifiers.org/xenbase/",
        "PR": "http://purl.obolibrary.org/obo/PR_",
        "MIPS_funcat": "http://mips.gsf.de/cgi-bin/proj/funcatDB/search_advanced.pl?action=2&wert=",
        "GR_REF": "http://www.gramene.org/db/literature/pub_search?ref_id=",
        "MaizeGDB": "http://maizegdb.org/gene_center/gene/",
        "HAMAP": "http://hamap.expasy.org/unirule/",
        "SGN_ref": "http://www.sgn.cornell.edu/chado/publication.pl?pub_id=",
        "TO_GIT": "https://github.com/Planteome/plant-trait-ontology/issues/",
        "MeSH": "http://n2t.net/MESH:",
        "GR_PROTEIN": "http://identifiers.org/gramene.protein/",
        "MaizeGDB_REF": "http://maizegdb.org/data_center/reference?id=",
        "GEO": "http://www.ncbi.nlm.nih.gov/sites/GDSbrowser?acc=",
        "PO": "http://purl.obolibrary.org/obo/PO_",
        "PomBase": "http://identifiers.org/pombase/",
        "ENA": "http://www.ebi.ac.uk/ena/data/view/",
        "PIRSF": "http://pir.georgetown.edu/cgi-bin/ipcSF?id=",
        "EMBL": "http://www.ebi.ac.uk/cgi-bin/emblfetch?style=html&Submit=Go&id=",
        "Prosite": "http://www.expasy.ch/cgi-bin/prosite-search-ac?",
        "H-invDB_cDNA": "http://www.h-invitational.jp/hinv/spsoup/transcript_view?acc_id=",
        "EC": "http://www.expasy.org/enzyme/",
        "MACSC_REF": "http://www.maizegdb.org/cgi-bin/displaytraitrecord.cgi?id=",
        "PAMGO_VMD": "http://vmd.vbi.vt.edu/cgi-bin/browse/go_detail.cgi?gene_id=",
        "IRGC": "https://www.genesys-pgr.org/acn/search?q=IRGC+",
        "NASC_code": "http://seeds.nottingham.ac.uk/NASC/stockatidb.lasso?code=",
        "COG_Cluster": "http://www.ncbi.nlm.nih.gov/COG/new/release/cow.cgi?cog=",
        "TreeGenes": "http://dendrome.ucdavis.edu/treegenes/protein/view_protein.php?id=",
        "WB_REF": "http://www.wormbase.org/db/misc/paper?name=",
        "TGD_LOCUS": "http://db.ciliate.org/cgi-bin/locus.pl?locus=",
        "MA": "http://purl.obolibrary.org/obo/MA_",
        "UniProtKB": "http://identifiers.org/uniprot/",
        "MGI": "http://identifiers.org/mgi/",
        "GRINDesc": "https://npgsweb.ars-grin.gov/gringlobal/descriptordetail.aspx?id=",
        "DDANAT": "http://purl.obolibrary.org/obo/DDANAT_",
        "RAP-DB": "http://rapdb.dna.affrc.go.jp/tools/search/run?id=on&attr=desc&attr=cgs&attr=cgn&attr=cgss&attr=cgns&attr=rgss&attr=rgns&keyword=",
        "KEGG_PATHWAY": "http://identifiers.org/kegg.pathway/",
        "JCVI_CMR": "http://cmr.jcvi.org/cgi-bin/CMR/shared/GenePage.cgi?locus=",
        "dictyBase_REF": "http://dictybase.org/db/cgi-bin/dictyBase/reference/reference.pl?refNo=",
        "DOI": "http://dx.doi.org/",
        "LIFEdb": "http://www.dkfz.de/LIFEdb/LIFEdb.aspx?ID=",
        "PANTHER": "http://identifiers.org/panther.family/",
        "Gene3D": "http://gene3d.biochem.ucl.ac.uk/search?mode=family&sterm=",
        "PATRIC": "http://patric.vbi.vt.edu/gene/overview.php?fid=",
        "FB": "http://identifiers.org/flybase/",
        "PAINT_REF": "http://www.pantherdb.org/panther/lookupId.jsp?id=PTHR",
        "CASREF": "http://research.calacademy.org/research/ichthyology/catalog/getref.asp?id=",
        "ENSEMBL": "http://identifiers.org/ensembl/",
        "SMART": "http://smart.embl-heidelberg.de/smart/do_annotation.pl?BLAST=DUMMY&DOMAIN=",
        "RefSeq": "http://www.ncbi.nlm.nih.gov/entrez/viewer.fcgi?val=",
        "WBls": "http://purl.obolibrary.org/obo/WBls_",
        "MaizeGDB_QTL": "http://www.maizegdb.org/data_center/trait?id=",
        "SOY_ref": "http://www.soybase.org/sbt/search/search_results.php?category=Soybase_ID&search_term=",
        "ECO": "http://purl.obolibrary.org/obo/ECO_",
        "CGD_REF": "http://www.candidagenome.org/cgi-bin/reference/reference.pl?dbid=",
        "ECK": "http://www.ecogene.org/geneInfo.php?eck_id=",
        "CGD": "http://identifiers.org/cgd/",
        "GR_GENE": "http://identifiers.org/gramene.gene/",
        "RNAmods": "http://s59.cas.albany.edu/RNAmods/cgi-bin/rnashow.cgi?",
        "KEGG_ENZYME": "http://identifiers.org/kegg.enzyme/",
        "CACAO": "http://gowiki.tamu.edu/wiki/index.php/",
        "IUPHAR_GPCR": "http://www.iuphar-db.org/DATABASE/FamilyMenuForward?familyId=",
        "JCVI_TIGRFAMS": "http://search.jcvi.org/search?p&q=",
        "SOY_QTL": "http://soybase.org/sbt/search/search_results.php?category=QTLName&search_term=",
        "DDBJ": "http://arsa.ddbj.nig.ac.jp/arsa/ddbjSplSearch?KeyWord=",
        "PRINTS": "http://www.bioinf.manchester.ac.uk/cgi-bin/dbbrowser/sprint/searchprintss.cgi?display_opts=Prints&category=None&queryform=false&regexpr=off&prints_accn=",
        "PO_REF": "http://planteome.org/po_ref/",
        "IMG": "http://img.jgi.doe.gov/cgi-bin/pub/main.cgi?section=GeneDetail&page=geneDetail&gene_oid=",
        "CL": "http://purl.obolibrary.org/obo/CL_",
        "UniProtKB-SubCell": "http://www.uniprot.org/locations/",
        "NIF_Subcellular": "http://www.neurolex.org/wiki/",
        "GeneDB": "http://identifiers.org/genedb/",
        "ApiDB_PlasmoDB": "http://www.plasmodb.org/gene/",
        "RNAcentral": "http://rnacentral.org/rna/",
        "CGD_LOCUS": "http://www.candidagenome.org/cgi-bin/locus.pl?locus=",
        "Rfam": "http://rfam.sanger.ac.uk/family/",
        "Broad_NEUROSPORA": "http://www.broadinstitute.org/annotation/genome/neurospora/GeneDetails.html?sp=S",
        "AGI_LocusCode": "http://arabidopsis.org/servlets/TairObject?type=locus&name=",
        "OBO_SF2_PO": "http://sourceforge.net/p/obo/plant-ontology-po-term-requests/",
        "FMA": "http://purl.obolibrary.org/obo/FMA_",
        "CDD": "http://www.ncbi.nlm.nih.gov/Structure/cdd/cddsrv.cgi?uid=",
        "PubChem_Compound": "http://www.ncbi.nlm.nih.gov/entrez/query.fcgi?CMD=search&DB=pccompound&term=",
        "HGNC_gene": "http://identifiers.org/hgnc.gene/",
        "PharmGKB": "http://www.pharmgkb.org/do/serve?objId=",
        "VMD": "http://vmd.vbi.vt.edu/cgi-bin/browse/browserDetail_new.cgi?gene_id=",
        "UniParc": "http://www.uniprot.org/uniparc/",
        "MEROPS": "http://merops.sanger.ac.uk/cgi-bin/pepsum?mid=",
        "GDB": "http://www.gdb.org/gdb-bin/genera/accno?accessionNum=GDB:",
        "SEED": "http://www.theseed.org/linkin.cgi?id=",
        "SO": "http://purl.obolibrary.org/obo/SO_",
        "Soy_gene": "http://www.soybase.org/sbt/search/search_results.php?category=FeatureName&search_term=",
        "CORUM": "http://mips.gsf.de/genre/proj/corum/complexdetails.html?id=",
        "RHEA": "http://www.rhea-db.org/reaction.xhtml?id=",
        "dbSNP": "http://identifiers.org/dbsnp/",
        "MaizeGDB_Locus": "http://identifiers.org/maizegdb.locus/",
        "MO": "http://mged.sourceforge.net/ontologies/MGEDontology.php#",
        "PLANA_REF": "http://purl.obolibrary.org/obo/plana/references/",
        "BRENDA": "http://www.brenda-enzymes.info/php/result_flat.php4?ecno=",
        "ASAP": "https://asap.ahabs.wisc.edu/annotation/php/feature_info.php?FeatureID=",
        "CAS": "http://identifiers.org/cas/",
        "H-invDB_locus": "http://www.h-invitational.jp/hinv/spsoup/locus_view?hix_id=",
        "UM-BBD_ruleID": "http://eawag-bbd.ethz.ch/servlets/rule.jsp?rule=",
        "NCBITaxon": "http://purl.obolibrary.org/obo/NCBITaxon_",
        "ComplexPortal": "https://www.ebi.ac.uk/complexportal/complex/",
        "JSTOR": "http://www.jstor.org/stable/",
        "GRIMS": "https://www.genesys-pgr.org/acn/search2?q=IRGC+",
        "PATO": "http://purl.obolibrary.org/obo/PATO_",
        "GR_QTL": "http://identifiers.org/gramene.qtl/",
        "ECOGENE": "http://www.ecogene.org/geneInfo.php?eg_id=",
        "HPA_antibody": "http://www.proteinatlas.org/antibody_info.php?antibody_id=",
        "VBRC": "http://vbrc.org/query.asp?web_id=VBRC:",
        "EO_GIT": "https://github.com/Planteome/plant-environment-ontology/issues/",
        "EchoBASE": "http://www.biolws1.york.ac.uk/echobase/Gene.cfm?recordID=",
        "CASGEN": "http://research.calacademy.org/research/ichthyology/catalog/getname.asp?rank=Genus&id=",
        "IUPHAR_RECEPTOR": "http://www.iuphar-db.org/DATABASE/ObjectDisplayForward?objectId=",
        "IRIC": "http://oryzasnp.org/_variety.zul?irisid=",
        "GenBank": "http://www.ncbi.nlm.nih.gov/entrez/viewer.fcgi?db=nucleotide&val=",
        "TGD": "http://identifiers.org/tgd/",
        "JCVI_EGAD": "http://cmr.jcvi.org/cgi-bin/CMR/EgadSearch.cgi?search_string=",
        "PubChem_BioAssay": "http://pubchem.ncbi.nlm.nih.gov/assay/assay.cgi?aid=",
        "TC": "http://www.tcdb.org/tcdb/index.php?tc=",
        "SABIO-RK": "http://sabio.villa-bosch.de/reacdetails.jsp?reactid=",
        "OBO_SF2_PECO": "https://sourceforge.net/p/obo/plant-environment-ontology-eo/",
        "MetaCyc": "http://identifiers.org/metacyc/",
        "PAMGO_GAT": "http://agro.vbi.vt.edu/public/servlet/GeneEdit?&Search=Search&level=2&genename=",
        "ModBase": "http://salilab.org/modbase/searchbyid?databaseID=",
        "OMIM": "http://omim.org/entry/",
        "GR_MUT": "http://www.gramene.org/db/genes/search_gene?acc=",
        "HPA": "http://www.proteinatlas.org/tissue_profile.php?antibody_id=",
        "IntAct": "http://identifiers.org/intact/",
        "ProDom": "http://prodom.prabi.fr/prodom/current/cgi-bin/request.pl?question=DBEN&query=",
        "GRIN": "https://npgsweb.ars-grin.gov/gringlobal/accessiondetail.aspx?id=",
        "WBPhenotype": "http://purl.obolibrary.org/obo/WBPhenotype_",
        "BioCyc": "http://biocyc.org/META/NEW-IMAGE?type=PATHWAY&object=",
        "ENSEMBL_GeneID": "http://www.ensembl.org/id/",
        "PIR": "http://pir.georgetown.edu/cgi-bin/pirwww/nbrfget?uid=",
        "UniProtKB-KW": "http://www.uniprot.org/keywords/",
        "Planteome_gene": "https://www.google.com/search?q=",
        "AspGD": "http://www.aspergillusgenome.org/cgi-bin/locus.pl?dbid=",
        "JCVI_Medtr": "http://medicago.jcvi.org/cgi-bin/medicago/search/shared/ORF_infopage.cgi?orf=",
        "EuPathDB": "http://eupathdb.org/gene/",
        "PMCID": "http://www.ncbi.nlm.nih.gov/sites/entrez?db=pmc&cmd=search&term="
    }
}
